module.exports = __webpack_public_path__ + "static/media/categories-logo-salesforce.9a632259.svg";